import React from 'react';
import { TimeGrid }        from '../components/TimeGrid/TimeGrid';
import { MobileTimesheet } from './MobileTimesheet';
import { useAuth }         from '../context/AuthContext';
import { useIsMobile }     from '../hooks/useMediaQuery';

export function TimesheetPage() {
  const { user } = useAuth();
  const isMobile = useIsMobile();
  if (!user) return null;
  return isMobile
    ? <MobileTimesheet currentUserId={user.id} />
    : <TimeGrid       currentUserId={user.id} />;
}
